import { api } from "@/lib/axios";
import type { AuthSnapshot, TenantSummary, AuthUser } from "@/modules/auth/store/auth.store";

/**
 * Auth API klient — backend kontrakti:
 * `docs/architecture/auth-api-contract.md` (2-bo'lim)
 */

export interface LoginPayload {
  email: string;
  password: string;
  tenantSlug?: string;
}

interface LoginResponseDTO {
  accessToken: string;
  accessTokenExpiresAt: string;
  user: AuthUser & { lastLoginAt?: string | null };
  tenant: TenantSummary;
  tenants: TenantSummary[];
}

interface MeResponseDTO {
  user: AuthUser & { lastLoginAt?: string | null };
  currentTenant: TenantSummary;
  tenants: TenantSummary[];
  session?: { id: string; expiresAt: string };
}

/** Kelgan DTO'ni store snapshot'iga o'tkazish */
function toSnapshot(dto: LoginResponseDTO): AuthSnapshot {
  return {
    accessToken: dto.accessToken,
    accessTokenExpiresAt: dto.accessTokenExpiresAt,
    user: dto.user,
    currentTenant: dto.tenant,
    tenants: dto.tenants,
  };
}

export const authApi = {
  login: async (payload: LoginPayload): Promise<AuthSnapshot> => {
    const res = await api.post<LoginResponseDTO>("/auth/login", payload);
    return toSnapshot(res.data);
  },

  logout: async (): Promise<void> => {
    await api.post("/auth/logout");
  },

  me: async (): Promise<MeResponseDTO> => {
    const res = await api.get<MeResponseDTO>("/auth/me");
    return res.data;
  },

  switchTenant: async (tenantId: string): Promise<AuthSnapshot> => {
    const res = await api.post<LoginResponseDTO>("/auth/switch-tenant", { tenantId });
    return toSnapshot(res.data);
  },
};
